export const status = [
  {
    name: '是',
    code: true
  },
  {
    name: '否',
    code: false
  }
]

export const validators = [
  {
    name: '必填',
    code: 'required'
  }
]

export const expandFieldTypes = [
  {
    name: '单行文本',
    code: 'input'
  },
  {
    name: '多行文本',
    code: 'textarea'
  },
  {
    name: '数字',
    code: 'number'
  },
  {
    name: '日期',
    code: 'date'
  },
  {
    name: '单选',
    code: 'radio'
  },
  {
    name: '下拉',
    code: 'select'
  }
]

export const formatNumber = [
  {
    name: '千分位',
    code: 'thousand'
  },
  {
    name: '百分号',
    code: 'percent'
  }
]

export const formatDate = [
  {
    name: 'YYYY-MM',
    code: 'YYYY-MM'
  },
  {
    name: 'YYYY年MM月',
    code: 'YYYY年MM月'
  },
  {
    name: 'YYYY-MM-DD',
    code: 'YYYY-MM-DD'
  },
  {
    name: 'YYYY年MM月DD日',
    code: 'YYYY年MM月DD日'
  },
  {
    name: 'YYYY-MM-DD HH:mm',
    code: 'YYYY-MM-DD HH:mm'
  },
  {
    name: 'YYYY-MM-DD HH:mm:ss',
    code: 'YYYY-MM-DD HH:mm:ss'
  }
]

export const selectType = [
  {
    name: '数据字典',
    code: 'dict'
  },
  {
    name: '自定义',
    code: 'custom'
  }
]
